import { buildMiddleware } from 'utilities/state';
import repository from 'client/repository';
import { DateTime } from 'luxon';

const stateKey = 'cards';
const rootStoreKey = 'store:cards';

const cardCheckerKey = 'state:user';
const storeCardKey = `${rootStoreKey}.cardData`;
const storePassKey = `${rootStoreKey}.passes`;

// Age in minutes a card can be before data is removed
const CardAgeCutoff = -5;

const serialize = (appStore, state) => {

    const configState = state[stateKey] || {};
    const cardData = configState.cards || {};
    const passData = configState.passes || {};

    const cardCheckerCard = appStore.get(cardCheckerKey) || '';
    const activeQrCode = cardData.currentQrCode;

    // Remove all heavy data from the card as we will go back to the server to fetch
    // this whenever we need to render it
    Object.keys(cardData).forEach(key => {
        const card = cardData[key];

        if (key !== activeQrCode && key !== cardCheckerCard) {

            const dateFetched = DateTime.fromISO(card.cardData.dateRetrieved);

            const cardAge = dateFetched.diffNow().as('minutes');

            // expire data after a small period
            if (cardAge < CardAgeCutoff) {

                // delete the card image and any additional data
                if (card.card) {
                    delete card.card;
                }

                if (card.competenceData) {
                    delete card.competenceData;
                }

                // Flag the card as requiring a reload
                card.isDirty = true;
            }
        }
    });

    const cloned = {
        ...configState
    };

    delete cloned.cards;
    delete cloned.passes;

    appStore.set(rootStoreKey, cloned);
    appStore.set(storeCardKey, cardData);
    appStore.set(storePassKey, passData);
};

const deserialize = (appStore, state) => {

    return new Promise((resolve, reject) => {     
        
        const data = {
            cards: appStore.get(storeCardKey) || {},
            passes: appStore.get(storePassKey) || {},
            ...appStore.get(rootStoreKey),
        };

        state[stateKey] = data;

        let resolveImmediate = true;

        if (data.currentQrCode) {
            const card = data.cards[data.currentQrCode];
            if (card && !card.hasOwnProperty('card')) {
                resolveImmediate = false;

                // does the card data on display need rehydrating?
                repository.cards.getCardDataByQR(card.qrCode, true, true).then(card => {

                    data.cards[data.currentQrCode] = card;
                    card.cardData.dateRetrieved = new Date().toISOString();

                    resolve();

                }).catch(e => {
                    console.error(e);
                    reject();
                });
            }
        }

        if (resolveImmediate) {
            resolve();
        }
    });
};

export default buildMiddleware(serialize, deserialize);